import { faAngleDown } from "@fortawesome/free-solid-svg-icons/faAngleDown";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons/faAngleRight";
import { faBan } from "@fortawesome/free-solid-svg-icons/faBan";
import { faBucket } from "@fortawesome/free-solid-svg-icons/faBucket";
import { faCamera } from "@fortawesome/free-solid-svg-icons/faCamera";
import { faCheck } from "@fortawesome/free-solid-svg-icons/faCheck";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons/faCircleInfo";
import { faClipboardList } from "@fortawesome/free-solid-svg-icons/faClipboardList";
import { faEdit } from "@fortawesome/free-solid-svg-icons/faEdit";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons/faInfoCircle";
import { faMoneyCheckDollar } from "@fortawesome/free-solid-svg-icons/faMoneyCheckDollar";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons/faTimesCircle";
import { faTriangleExclamation } from "@fortawesome/free-solid-svg-icons/faTriangleExclamation";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as R from 'ramda'
import { AmbienteItemComMenu } from '../ambiente/AmbienteItemComMenu';
import { Popover } from 'app/components/popover/Popover';
import { controleNavegacaoGridItens } from 'controleNavegacaoGridItens2'
import { obterStyleColunasFixas, obterStylePrimeiraColuna } from './obterStyleColunasFixas';
import { InputNumerico } from 'app/components/inputs/InputNumerico';
import { TooltipMU } from 'app/components/tooltip/TooltipMU';
import { InputDataCalendario } from "app/components/inputs/InputDataCalendario";
import { CodigoTipoEntrega } from "app/types/CodigoTipoEntrega";
import { CodigoTurnoEntrega } from "app/types/CodigoTurnoEntrega";
import { IColuna } from "app/types/IColuna";
import { IItemOrcamento } from "app/types/IItemOrcamento";
import { v4 as uuidv4 } from 'uuid'
import clsx from "clsx";
import globalMU from "globalMU";
import React, { memo, useContext, useEffect, useMemo, useRef, useState } from "react";
import { ModalServicosAgregadosContainer } from "app/components/servicos-agregados/ModalServicosAgregadosContainer";
import { ListaTurnoEntrega } from "app/components/editar-item/EditarItem";
import { GridItensContext } from './GridItens';
import { DURACAO_ANIMACAO_REMOCAO_MS } from 'app/utils/animacoes';

const estilosGridItens = require('./grid-itens.module.scss').default
const estilosBotoes = require('../../../estilos/botoes.module.scss').default
const estilosLegenda = require('../legenda/legenda.module.scss').default

declare var window: any

const ID_GRID_ITENS = "grid-itens"

type ItemProps = {
    item: IItemOrcamento,
    indexItem?: number,
    /** 491123 — true só na última linha clicada; em touch é o que libera o painel de ações flutuante */
    exibirAcoesFlutuantesTouch?: boolean
    /** 491123 — avisa a grade de que esta é a linha clicada mais recente */
    onLinhaClicada?: () => void
    onExpandirSubItensClicado?: (expandir: boolean) => void
    onMenuAmbientesAberto: (larguraContainer: number) => void
    ocultarAcoesFlutuantes?: boolean
    onExibicaoMenuAmbientesAlterada?: (exibindo: boolean) => void
    onMouseSobreMenuAmbientes?: (sobre: boolean) => void
}

type ColunaCoreProps = {
    indexItem: number
    item?: IItemOrcamento
}

const ColunaCor = memo(({
    indexItem,
    item,
}: ColunaCoreProps) => {
    const context = useContext(GridItensContext)

    const parametroOfertaSeletiva = useMemo(() =>
        (context.parametrosGridItens ?? []).find(p => p.Nome == "OFERTA_SELETIVA")?.Valor === "S",
        [context.parametrosGridItens]
    )

    const boxShadowStyle = useMemo(() => {
        return globalMU.isNullOrEmpty(item.Cor) || item.Cor === "#000000"
            ? undefined
            : { boxShadow: `25px 0 ${item.Cor} inset` }
    }, [item.Cor])

    const backgroundColorStyle = useMemo(() => ({
        backgroundColor: !item.selecionado
            ? undefined
            : (globalMU.isNullOrEmpty(context.corItemSelecionado) ? "#fafaad" : context.corItemSelecionado)
    }), [item.selecionado, context.corItemSelecionado])

    const hasAlertas = useMemo(() => (item.Alertas ?? []).length > 0, [item.Alertas])
    const showVendendoSemEstoque = useMemo(() =>
        !hasAlertas && item.VendendoProdutoSemEstoque,
        [hasAlertas, item.VendendoProdutoSemEstoque]
    )

    return (
        <td
            className={clsx(
                "_cursor-pointer",
                estilosGridItens.colunaVazia,
                estilosGridItens.colunaFixa,
                estilosGridItens.primeiraColuna
            )}
            title={!globalMU.isNullOrEmpty(item?.DescricaoLegenda) ? item?.DescricaoLegenda : undefined}
            onClick={() => context.onSelecionarItem(item)}
            id={`Item_cor_td_Linha_${item.Index}_${indexItem}`}
            key={`Item_cor_td_Linha_${item.Index}_${indexItem}`}
            style={{
                ...boxShadowStyle,
                ...backgroundColorStyle,
                ...obterStylePrimeiraColuna()
            }}
        >
            {item.OrdemItem === "I" && (
                <div className={estilosLegenda.produtoImportadoCor}
                    id={`Item_cor_td_Linha_div_ordem_${item.Index}_${indexItem}`}
                    key={`Item_cor_td_Linha_div_ordem_${item.Index}_${indexItem}`}
                />
            )}

            {item.OfertaSelecionada === 1 && parametroOfertaSeletiva && (
                <FontAwesomeIcon
                    icon={faCheck}
                    style={{ color: "white" }}
                    title="Oferta Selecionada"
                    id={`Item_Icone_OfertaSeletivaSelecionada_td_Linha_${item.Index}`}
                    key={`Item_Icone_OfertaSeletivaSelecionada_td_Linha_${item.Index}_${indexItem}`}
                />
            )}

            {item.ExistePendenciaEstoqueDisponivelNaFilialDaVenda != null && item.ExistePendenciaEstoqueDisponivelNaFilialDaVenda && (
                <Popover
                    id={`Item_PopoverIcone_AlertaComEstoqueFilialVenda_td_Linha_${item.Index}_${indexItem}`}
                    key={`Item_PopoverIcone_AlertaComEstoqueFilialVenda_td_Linha_${item.Index}_${indexItem}`}
                    conteudo="Estoque disponível na filial da venda"
                    exibirConteudoComoTitle={true}
                >
                    <FontAwesomeIcon
                        icon={faTriangleExclamation}
                        style={{ color: 'DarkTurquoise' }}
                        className="_text-3xl"
                        id={`Item_Icone_AlertaComEstoqueFilialVenda_td_Linha_${item.Index}_${indexItem}`}
                        key={`Item_Icone_AlertaComEstoqueFilialVenda_td_Linha_${item.Index}_${indexItem}`}
                    />
                </Popover>
            )}

            {hasAlertas ? (
                <Popover
                    id={`Item_PopoverIcone_Alerta_td_Linha_${item.Index}_${indexItem}`}
                    key={`Item_PopoverIcone_Alerta_td_Linha_${item.Index}_${indexItem}`}
                    conteudo={item.Alertas.map(a => a.Mensagem).join("\n")}
                    exibirConteudoComoTitle={true}
                >
                    <FontAwesomeIcon
                        icon={faTriangleExclamation}
                        style={{ color: '#F00' }}
                        className="_text-3xl"
                        id={`Item_Icone_Alerta_td_Linha_${item.Index}_${indexItem}`}
                        key={`Item_Icone_Alerta_td_Linha_${item.Index}_${indexItem}`}
                    />
                </Popover>
            ) : showVendendoSemEstoque && (
                <Popover
                    id={`Item_PopoverIcone_Informacao_td_Linha_${item.Index}_${indexItem}`}
                    key={`Item_PopoverIcone_Informacao_td_Linha_${item.Index}_${indexItem}`}
                    conteudo="Venda de Produto Sem Estoque Disponível"
                    exibirConteudoComoTitle={true}
                >
                    <FontAwesomeIcon
                        icon={faCircleInfo}
                        style={{ color: 'white' }}
                        className="_text-3xl"
                        id={`Item_Icone_Informacao_td_Linha_${item.Index}_${indexItem}`}
                        key={`Item_Icone_Informacao_td_Linha_${item.Index}_${indexItem}`}
                    />
                </Popover>
            )}
        </td>
    )
})

const Item = (props: ItemProps) => {
    const context = useContext(GridItensContext)
    const isMounted = useRef<boolean>(true)

    const filiaisRetirada = context.filiaisRetiradaPorItem[props.item.Identificador] ?? []
    const filiaisTransferencia = context.filiaisTransferenciaPorItem[props.item.Identificador] ?? []
    const tiposFreteDisponiveis = context.tiposFreteDisponiveisPorItem[props.item.Identificador] ?? []

    const parametroChaveMovimentacaoOrcamento = useMemo(() =>
        (context.parametrosGridItens ?? []).find(p => p.Nome == "CHAVE_MOVIMENTACAO_ORCAMENTO")?.Valor as "C" | "R",
        [context.parametrosGridItens]
    )

    const [item, setItem] = useState<IItemOrcamento>(props.item)
    const [quantidade, setQuantidade] = useState<number>(props.item.Quantidade)
    const [preco, setPreco] = useState<number>(props.item.PrecoProduto)
    const [percentualMarkup, setPercentualMarkup] = useState<number>(props.item.PercentualMarkUp)
    const [idListaCentroCusto] = useState(uuidv4())
    const [pedidoCompra, setPedidoCompra] = useState(props.item.PedidoCompra)
    const [linhaOrdemPedidoCompra, setLinhaOrdemPedidoCompra] = useState(props.item.PedidoCompraCliente ?? "")
    const [nomeCentroCusto, setNomeCentroCusto] = useState(props.item.NomeCentroCusto)
    //const [ultimaAtualizacaoOrcamento, setUltimaAtualizacaoOrcamento] = useState(context.orcamento.UltimaAtualizacao)
    const [observacaoDoItem, setObservacaoDoItem] = useState(props.item.ObservacaoDoItem)
    // 493427 — animacao de saida ao excluir pela coluna Acoes: a linha esmaece virando vermelho
    // (classe linhaRemovendo) e a exclusao de verdade so acontece quando a animacao termina — mesmo
    // padrao da remocao de produto da cesta (TabelaProdutosSelecionados.tsx).
    const [removendo, setRemovendo] = useState(false)
    const [exibirServicosAgregados,setExibirServicosAgregados] = useState(false)
    const bloquearFaturamentoDiretoClienteRetiradaOutroLocal = context.parametrosGridItensPorFilial?.find(p => p.Nome == "BLOQUEAR_FATURAMENTO_DIRETO_CLIENTE_RETIRADA_OUTRO_LOCAL")?.Valor === "S" // 469010
    const parametroVendaSobEncomenda = context.parametrosGridItens?.find(p => p.Nome == "TRATAR_VENDAS_SOB_ENCOMENDA")?.Valor // 490854

    const [dirty, setDirty] = useState<{
        preco: boolean,
        quantidade: boolean,
        percentualMarkup: boolean,
        pedidoCompra: boolean,
        linhaOrdemPedidoCompra: boolean
    }>({ preco: false, quantidade: false, percentualMarkup: false, pedidoCompra: false, linhaOrdemPedidoCompra: false })

    const [subItensExpandido, setSubItensExpandido] = useState(false)

    const listaTurnoEntrega = useMemo<ListaTurnoEntrega[]>(() => {
        const turnos: ListaTurnoEntrega[] = [
            { Description: "Manhã", Value: "0" },
            { Description: "Tarde", Value: "1" }
        ]
        if (context.parametrosGridItens?.find(p => p.Nome == "DEFINIR_PREVISAO_ENTREGA_POR_ITEM")?.Valor == "S"
            && context.parametrosGridItensPorFilial?.find(p => p.Nome == "OBRIGATORIO_INFORMAR_TURNO_ORCAMENTO")?.Valor === "S") {
            turnos.push({ Description: "Noite", Value: "2" })
            turnos.push({ Description: "Indiferente", Value: "3" })
        }
        return turnos
    }, [context.parametrosGridItens, context.parametrosGridItensPorFilial])

    useEffect(() => () => { isMounted.current = false }, [])

    useEffect(() => {
        if (!isMounted.current) return

        setItem(props.item)

        if (quantidade != props.item.Quantidade)
            setQuantidade(props.item.Quantidade)

        if (preco != props.item.PrecoProduto)
            setPreco(props.item.PrecoProduto)

        if (percentualMarkup != props.item.PercentualMarkUp)
            setPercentualMarkup(props.item.PercentualMarkUp)

        if (pedidoCompra != props.item.PedidoCompra)
            setPedidoCompra(props.item.PedidoCompra)

        if (linhaOrdemPedidoCompra != (props.item.PedidoCompraCliente ?? ""))
            setLinhaOrdemPedidoCompra(props.item.PedidoCompraCliente ?? "")

        setNomeCentroCusto(item.NomeCentroCusto)

    }, [props.item])

    const exibirColuna = (coluna: IColuna) => context.colunas.find(c => c.Nome == coluna.Nome)?.Selecionada == true

    const confirmarAlteracaoPreco = (novoPreco: number) => {
        if (!isMounted.current) return
        context.onPrecoModificado(item.Identificador, novoPreco, null, null)

    }

    const aplicarPorcentagemDescontoUnitario = (novaPorcentagem: number) => {
        if (!isMounted.current) return
        if (item.ProdutoForaEstoque) // 474549 / 472775
            {
                globalMU.showErrorMessage("Não é possível aplicar desconto unitário em produtos fora de estoque.")
                return
            }
        context.onPorcentagemDescontoUnitarioModificado(item.Identificador, item.PrecoUnitarioTabela, novaPorcentagem, true)
    }

    const onModificadoPreservarDescontoUnitario = (preservarDescontoUnitario: boolean) => {
        if (!isMounted.current) return
        context.onModificadoPreservarDescontoUnitario(item.Identificador, item.PrecoProduto, item.PercentualDesconto, preservarDescontoUnitario)
    }

    const confirmarAlteracaoQuantidade = (novaQuantidade: number) => {
        if (!isMounted.current) return

        setQuantidade(novaQuantidade)
        context.onQuantidadeModificada(item.Identificador, novaQuantidade)

    }

    const confirmarAlteracaoPercentualMarkup = (novoPercentualMarkup: number) => {
        if (!isMounted.current) return

        context.onPercentualMarkupModificado(item.Identificador, novoPercentualMarkup)

    }

    const abrirModalServicoAgregado = (e) =>{
        if (!isMounted.current) return
        if (e) {
            setExibirServicosAgregados(true)
        } else {
            setExibirServicosAgregados(false)
        }
    }

    const iconeExpansao = (idUnico: string) => {
    return (
    <div className="_rounded-full _text-gray-300 _text-2xl _px-1 _bg-gray-600 _cursor-pointer"
        style={{maxHeight:"26px"}}
        key={`item_IconeExpadirTinta_${idUnico}_${props.indexItem}`}
        id={`item_IconeExpadirTinta_${idUnico}_${props.indexItem}`}
        onClick={() => {
            if (!isMounted.current) return
            const next = !subItensExpandido
            setSubItensExpandido(next)
            props.onExpandirSubItensClicado?.(next)
        }}>
        <FontAwesomeIcon
            icon={subItensExpandido ? faAngleDown : faAngleRight}
            id={`item_IconeExpadirTinta_Icone_${idUnico}_${props.indexItem}`}
            key={`item_IconeExpadirTinta_Icone_${idUnico}_${props.indexItem}`}
            className="" />
    </div>
    )
}

    const existeColunaCodigo = () => context.colunas.find(c => c.Nome == "Codigo") != null

    const colunaCodigoEstaVisivel = () => context.colunas.find(c => c.Nome == "Codigo")?.Selecionada

    // sufixoId diferencia os ids/keys entre os botões da coluna normal e os da versão flutuante (hover), evitando id duplicado (#153)
    const renderBotoesAcoesItem = (sufixoId: string) => (
        <div className="_flex _flex-row _justify-start _gap-x-2"
            id={`Item_Acoes_Linha_${props.item.Index}${sufixoId}`}
        >

            <button className={clsx(estilosBotoes.botaoIcone, 'no-global-button')}
                title="Mostra informações detalhadas do produto"
                id={`Item_Acoes_BotaoInformacoesProduto_Linha-${props.item.Index}${sufixoId}`}
                key={`Item_Acoes_BotaoInformacoesProduto_Linha-${props.item.Index}${sufixoId}`}
            >
                <FontAwesomeIcon
                    icon={faInfoCircle}
                    onClick={() => context.onMostrarInformacoesProduto(item.Identificador)}
                    id={`Item_BotaoInformacoesProduto_Icone${sufixoId}`}
                 />
            </button>

            {props.item.IdCorTintometricoSimplicado <= 0 && props.item?.CodigoTinta > 0 && item.Classe.toLowerCase() !== "itempedidovendasubordinado" && // 455868
                <button
                    className={clsx(
                        estilosBotoes.botaoIcone,
                        estilosBotoes.botaoTintaAzul,
                        "no-global-button"
                      )}
                    title="Editar Preço Tinta"
                    id={`Item_Acoes_BotaoEditarTintometrico_Linha-${props.item.Index}${sufixoId}`}
                    key={`Item_Acoes_BotaoEditarTintometrico_Linha-${props.item.Index}${sufixoId}`}
                    onClick={() => context.onAlterarCorTintometrico(item.Identificador)}
                >
                </button>}
            {props.item.IdCorTintometricoSimplicado > 0 && item.Classe.toLowerCase() !== "itempedidovendasubordinado" && //PA 402355 repasse 311033
                <button
                    className={clsx(estilosBotoes.botaoIcone, 'no-global-button')}
                    title="Altera a cor da tinta"
                    id={`Item_Acoes_BotaoEditarTintometricoSimplificado_Linha-${props.item.Index}${sufixoId}`}
                    key={`Item_Acoes_BotaoEditarTintometricoSimplificado_Linha-${props.item.Index}${sufixoId}`}
                >
                    <FontAwesomeIcon icon={faBucket} onClick={() => context.onAlterarCorTintometricoSimplificado(item.Identificador)} />
                </button>} {/* PA 402355 repasse 311033 */}

            {(item.Imagens ?? []).length > 0 && item.Classe.toLowerCase() !== "itempedidovendasubordinado" &&
            <button className={clsx(estilosBotoes.botaoIcone, 'no-global-button')}
                title="Visualiza as imagens/vídeos do produto"
                id={`Item_Acoes_BotaoImagensProduto_Linha-${props.item.Index}${sufixoId}`}
                key={`Item_Acoes_BotaoImagensProduto_Linha-${props.item.Index}${sufixoId}`}
                >
                <FontAwesomeIcon icon={faCamera} onClick={() => context.onMostrarImagens(item.Identificador, `item-orcamento-identificador-${item.Identificador}`)} />
            </button>}

            {context.exibirIconeReservaLoteSePossivel && props.item.ControleLote && item.Classe.toLowerCase() !== "itempedidovendasubordinado" &&
                <button
                    title="Visualiza/Altera reserva de lote"
                    id={`Item_Acoes_BotaoReservarLote_Linha-${props.item.Index}${sufixoId}`}
                    key={`Item_Acoes_BotaoReservarLoteo_Linha-${props.item.Index}${sufixoId}`}
                className={clsx(estilosBotoes.botaoIcone, 'no-global-button')}
                onClick={() => context.onReservarLote(item.Identificador)}>
                <FontAwesomeIcon icon={faClipboardList} style={props.item.QuantidadeFaltante != 0 ? ({ color: "#f25713" }) : ({})} />
            </button>}

            {context.permitirVisualizarSimulacaoDePreco && props.item.PermitidoSimularPreco && item.Classe.toLowerCase() !== "itempedidovendasubordinado" &&  // 457575 /459162
                <button
                    title="Simulação de Precos&#0013;Veja parâmetro: [Permitir simular preço de produto bloqueado encomenda que seja de linha?]"
                    id={`Item_Acoes_BotaoSimularPrecos_Linha-${props.item.Index}${sufixoId}`}
                    key={`Item_Acoes_BotaoSimularPrecos_Linha-${props.item.Index}${sufixoId}`}
                    className={clsx(estilosBotoes.botaoIcone, 'no-global-button')}
                    onClick={() => context.onSimularPreco(item.Identificador)}>
                <FontAwesomeIcon
                    icon={faMoneyCheckDollar}
                    id={`Item_BotaoSimulacaoPrecoAcoes_Icone${sufixoId}`}
                 />
            </button>}


            {/* Exclui SO esta linha, sem depender do checkbox de selecao (o botao Excluir da barra
                de ferramentas exclui os itens selecionados). Escondido em orcamento somente leitura
                e em item subordinado, como o botao Editar abaixo. Fica ANTES do editar porque o
                comentario do editar avisa que ele tem de ser o ultimo botao de acoes. */}
            {!context.orcamento.SomenteLeitura && item.Classe.toLowerCase() !== "itempedidovendasubordinado" &&
            <button
                className={clsx(estilosBotoes.botaoIcone, 'no-global-button')}
                title="Exclui o item"
                id={`Item_Acoes_BotaoExcluirItem_Linha-${props.item.Index}${sufixoId}`}
                key={`Item_Acoes_BotaoExcluirItem_Linha-${props.item.Index}${sufixoId}`}
                disabled={removendo}
                onClick={(e) => {
                    // stopPropagation: o <tr> tem onClick (props.onLinhaClicada, do painel de acoes
                    // flutuante em touch) e as celulas chamam context.onSelecionarItem — sem isso o
                    // clique no X ainda borbulharia e mexeria na selecao da linha que esta saindo.
                    e.stopPropagation()

                    if (removendo) return

                    // Dispara a animacao de saida e so exclui de fato quando ela termina.
                    setRemovendo(true)
                    setTimeout(() => context.onExcluirItem(item), DURACAO_ANIMACAO_REMOCAO_MS)
                }}
            >
                {/* Sem `style` de cor: assim o icone herda o azul de `.botaoIcone > svg`
                    (base.$cor-icone em botoes.module.scss), igual aos outros botoes desta
                    coluna. O vermelho fica so no botao Excluir da barra de ferramentas. */}
                <FontAwesomeIcon
                    icon={faTimesCircle}
                    id={`Item_Acoes_BotaoExcluirItem_Icone_Linha-${props.item.Index}${sufixoId}`}
                />
            </button>}

            { item.Classe.toLowerCase() !== "itempedidovendasubordinado" && // 461135

            // botão editar deve ser o ultimo botao de acoes
            <button
                className={clsx(estilosBotoes.botaoIcone, 'no-global-button')}
                title="Edita o item"
                id={`Item_Acoes_BotaoEditarItem_Linha-${props.item.Index}${sufixoId}`}
                key={`Item_Acoes_BotaoEditarItem_Linha-${props.item.Index}${sufixoId}`}
            >
                <FontAwesomeIcon icon={faEdit} onClick={() => context.onEditarItem(item.Identificador)} />
            </button>

            // botão editar deve ser o ultimo botao de acoes
            }

        </div>
    )

/*


Atenção, se incluir alguma coluna no grid de itens, tem que incluir tambem na consulta de itens (ItemConsultaItens)



*/
    const componentesColunas: { [nomeColuna: string]: React.JSX.Element } = {
        "OrdemItem":
            <td
                id={`Item_Icone_Informacao_td_Linha_${item.Index}`}
                key={`Item_Icone_Informacao_td_Linha_${item.Index}`}
                onClick={() => context.onSelecionarItem(item)}
                className="_cursor-pointer"
                style={obterStyleColunasFixas("OrdemItem", context.colunas, parametroChaveMovimentacaoOrcamento, false)}
            >
                <div className="_flex _flex-row _justify-evenly">
                    <span className="_break-all">{item.OrdemItem}</span>
                </div>

            </td>,
        "Codigo":
            <td
                id={`Item_Icone_ColunaCodigo_td_Linha_${item.Index}`}
                key={`Item_Icone_ColunaCodigo_td_Linha_${item.Index}`}
                className="_cursor-pointer"
                style={obterStyleColunasFixas("Codigo", context.colunas, parametroChaveMovimentacaoOrcamento, 
                            item.CodigoTinta > 0 && existeColunaCodigo() && colunaCodigoEstaVisivel() && item.Classe.toLowerCase() == "itempedidovendasubordinado")} //461135
                >
                <div className="_flex _flex-row _justify-evenly"
                    id={`Item_Icone_ColunaCodigo_div_td_Linha_${item.Index}`}
                    key={`Item_Icone_ColunaCodigo_div_td_Linha_${item.Index}`}
                >
                    {props.item.PossuiSubItens && existeColunaCodigo() && colunaCodigoEstaVisivel() 
                        && iconeExpansao(`Item_Icone_ColunaCodigo_div_td_Linha_${item.Index}`)}

                    <div onClick={() => context.onSelecionarItem(item)}
                        id={`Item_Icone_ColunaCodigo_div2_td_Linha_${item.Index}`}
                        key={`Item_Icone_ColunaCodigo_div2_td_Linha_${item.Index}`}    
                    >
                        <span className="_break-all"
                            id={`Item_Icone_ColunaCodigo_div2_span_td_Linha_${item.Index}`}
                            key={`Item_Icone_ColunaCodigo_div2_span_td_Linha_${item.Index}`} 
                            style={ item.OidOferta > 7 ? {color: "var(--mu-azul-marcador, blue)"} : null}
                        >{item.Codigo}</span>
                    </div>
                </div>
            </td>,
        "Referencia":
            <td
                id={`Item_Referencia_td_Linha_${props.item.Index}`}
                key={`Item_Referencia_td_Linha_${props.item.Index}`}
                className="_cursor-pointer"
                title={`Código do produto: ${item.Codigo}`}
                style={obterStyleColunasFixas("Referencia", context.colunas, parametroChaveMovimentacaoOrcamento, 
                            item.CodigoTinta > 0 && (!existeColunaCodigo() || !colunaCodigoEstaVisivel()) && item.Classe.toLowerCase() == "itempedidovendasubordinado")}  //461135
            >
                <div className="_flex _flex-row _justify-evenly"
                    id={`Item_Referencia_div_td_Linha_${props.item.Index}`}
                    key={`Item_Referencia_div_td_Linha_${props.item.Index}`}
                >
                    {props.item.PossuiSubItens && (!existeColunaCodigo() || !colunaCodigoEstaVisivel()) 
                            && iconeExpansao(`Item_Referencia_div_td_Linha_${props.item.Index}`)}

                    <div onClick={() => context.onSelecionarItem(item)}>
                        <span className="_break-all"
                            style={ item.OidOferta > 7 ? {color: "var(--mu-azul-marcador, blue)"} : null}
                        >{item.ReferenciaProduto}</span>
                    </div>
                </div>
            </td>,
        "Descricao":
            context.exibirTextoTecnico && item.TextoTecnico?.replace(/\s/g, "")?.length > 0 ? (
                <td
                    id={`Item_Descricao_td_Linha_${props.item.Index}`}
                    key={`Item_Descricao_td_Linha_${props.item.Index}`}
                    className="_cursor-pointer"
                    onClick={() => context.onSelecionarItem(item)}
                    style={{
                        ...obterStyleColunasFixas("Descricao", context.colunas, parametroChaveMovimentacaoOrcamento, false),
                        ...(context.produtosFazemParteCampanhaCupomDesconto.filter(p => p == item.CodigoProduto).length > 0 ? { backgroundColor: "var(--mu-destaque, #FFFF9D)" } : null)
                    }}
                >
                    <TooltipMU
                        id={`Item_Descricao_ToolTipTextoTecnico_td_Linha_${props.item.Index}`}
                        key={`Item_Descricao_ToolTipTextoTecnico_td_Linha_${props.item.Index}`}
                        title={
                            <div style={{ whiteSpace: 'pre-wrap', textAlign: 'left' }}
                                id={`Item_Descricao_ToolTipTextoTecnico_div_td_Linha_${props.item.Index}`}
                                key={`Item_Descricao_ToolTipTextoTecnico_div_td_Linha_${props.item.Index}`}
                            >
                                <span style={{ color: 'gray', fontWeight: 'bold' }}
                                    id={`Item_Descricao_ToolTipTextoTecnico_div_Span_td_Linha_${props.item.Index}`}
                                    key={`Item_Descricao_ToolTipTextoTecnico_div_span_td_Linha_${props.item.Index}`}
                                >Texto técnico:</span> <br></br> {item.TextoTecnico?.replace(/(\f|\t)/g, (match) => {
                                    if (match === '\f') return ' ';
                                    if (match === '\t') return '    ';
                                })}
                            </div>
                        }
                    >
                        <span className="_break-all"
                            key={`Item_Descricao_ToolTipTextoTecnico_span_td_Linha_${props.item.Index}`}
                            id={`Item_Descricao_ToolTipTextoTecnico_span_td_Linha_${props.item.Index}`}
                            style={item.OidOferta > 7 ? { color: "var(--mu-azul-marcador, blue)", borderBottom: "1px dotted" } : { borderBottom: "1px dotted" }}

                        >{item.Descricao}</span>
                    </TooltipMU>
                </td>)
                :
                <td
                    id={`Item_Descricao2_td_Linha_${props.item.Index}`}
                    key={`Item_Descricao2_td_Linha_${props.item.Index}`}
                    className="_cursor-pointer"
                    onClick={() => context.onSelecionarItem(item)}
                    style={{
                        ...obterStyleColunasFixas("Descricao", context.colunas, parametroChaveMovimentacaoOrcamento, false),
                        ...(context.produtosFazemParteCampanhaCupomDesconto.filter(p => p == item.CodigoProduto).length > 0 ? { backgroundColor: "var(--mu-destaque, #FFFF9D)" } : null)
                    }}
                >
                    <span className="_break-all" 
                        id={`Item_Descricao2_span_td_Linha_${props.item.Index}`}
                        key={`Item_Descricao2_span_td_Linha_${props.item.Index}`}
                        style={ item.OidOferta > 7 ? {color: "var(--mu-azul-marcador, blue)"} : null}
                    >{item.Descricao}</span>
                </td>,
        "Unidade":
            <td 
                id={`Item_Unidade_td_Linha_${props.item.Index}`}
                key={`Item_Unidade_td_Linha_${props.item.Index}`}
                className="grid-itens__unidade _cursor-pointer"
                onClick={() => context.onSelecionarItem(item)}>
                {item.Unidade}
            </td>,
        "Quantidade":
            <td 
                className="grid-itens__qtd-editavel"
                id={`Item_Quantidade_td_Linha_${props.item.Index}`}
                key={`Item_Quantidade_td_Linha_${props.item.Index}`}
            >
                <InputNumerico
                    valor={quantidade}
                    onValorModificado={confirmarAlteracaoQuantidade}
                    numeroCasasDecimais={context.numeroCasasDecimaisQuantidade}
                    disabled={context.orcamento.SomenteLeitura || item.EtiquetaPesagem || (item.Madeira == true) || (item.Classe.toLowerCase() == "itempedidovendasubordinado")} // 461135
                    selecionaValorOnFocus={true}
                    onKeyDown={e => controleNavegacaoGridItens.tratarEvento(e, ID_GRID_ITENS)}
                    style={{ maxWidth: '100px', minWidth: '50px' }}
                    classesInput={["input-navegavel"]}
                    id={`input-Quantidade-item-Linha-${props.item.Index}`}
                    key={`input-Quantidade-item-Linha-${props.item.Index}`}
                    title={(item.Madeira == true) 
                                ? "Desabilitado por ser produto com tratamento madeira" 
                                : item.EtiquetaPesagem 
                                        ? "Entrada do produto realizada através da leitura de etiqueta. Quantidade do produto não pode ser alterada." 
                                        : undefined
                            }
                />


            </td>,
        "QuantidadeSolicitada":
            <td 
                id={`item_colunaQuantidadeSolicitada_td_Linha_${props.item.Index}`}
                key={`item_colunaQuantidadeSolicitada_td_Linha_${props.item.Index}`}
                className="_cursor-pointer d"
                onClick={() => context.onSelecionarItem(item)}>{globalMU.formatarValorNumerico(item.QuantidadeSolicitada, context.numeroCasasDecimaisQuantidade, false)} </td>,
        "QuantidadePendente":
            <td key="QuantidadePendente" className="_cursor-pointer d" onClick={() => context.onSelecionarItem(item)}>
                {globalMU.formatarValorNumerico(item.QuantidadePendente, context.numeroCasasDecimaisQuantidade, false)}
            </td>,
        "EstoqueTotal":
            <td 
                id={`Item_EstoqueTotal_td_Linha_${props.item.Index}`}
                key={`Item_EstoqueTotal_td_Linha_${props.item.Index}`}
                className="_cursor-pointer d" 
                onClick={() => {
                    
                    context.onSelecionarItem(item)}
                    }>
                {globalMU.formatarValorNumerico(item.QuantidadeEstoqueTotal, context.numeroCasasDecimaisQuantidade, false)}
            </td>,
        "PrecoUnitario": <td 
            className="grid-itens__preco-unitario"
            id={`Item_PrecoUnitario_td_Linha_${props.item.Index}`}
            key={`Item_PrecoUnitario_td_Linha_${props.item.Index}`}
            >
            <InputNumerico
                valor={preco}
                onValorModificado={(novoPreco) => { 
                    confirmarAlteracaoPreco(novoPreco);
                    setPreco(novoPreco);
                }}
                numeroCasasDecimais={context.numeroCasasDecimaisPreco}
                disabled={item.NaoPermiteAlterarPreco || context.orcamento.SomenteLeitura || (item.Madeira == true)}
                style={item.DescontoPendente ? { color: '#F00', maxWidth: '120px', minWidth: '50px' } : { maxWidth: '120px', minWidth: '50px' }}
                selecionaValorOnFocus={true}
                onKeyDown={e => controleNavegacaoGridItens.tratarEvento(e, ID_GRID_ITENS)}
                classesInput={["input-navegavel"]}
                id={`Item_inputPrecoUnitario_td_Linha_${props.item.Index}`}
                key={`Item_inputPrecoUnitario_td_Linha_${props.item.Index}`}
                title={ props.item.PossuiSubItens && props.item.PrecoTinta > 0 
                                ? `Preço Tinta: ${globalMU.formatarValorNumerico(props.item.PrecoTinta, context.numeroCasasDecimaisPreco, true)}` 
                                : (item.Madeira == true) ? "Desabilitado por ser produto com tratamento madeira" 
                                            : "Veja parâmetro: Altera preço de venda no Orçamento"}
            />

        </td>,
        "PorcentagemDescontoUnitario": <td 
                id={`Item_PorcentagemDescontoUnitario_td_Linha_${props.item.Index}`}
                key={`Item_PorcentagemDescontoUnitario_td_Linha_${props.item.Index}`}
            >
                {!item.ProdutoForaEstoque && // 474549 / 472775
            <InputNumerico
                valor={item.PercentualDesconto}
                onValorModificado={aplicarPorcentagemDescontoUnitario}
                disabled={context.orcamento.SomenteLeitura 
                                || props.item.BloqueiaUsuarioDarDescontoUnitarioOrcamento 
                                || item.CodigoTinta > 0} // 431591
                selecionaValorOnFocus={true}
                onKeyDown={e => controleNavegacaoGridItens.tratarEvento(e, ID_GRID_ITENS)}
                style={{ maxWidth: '70px', minWidth: '50px'}}
                id={`Item_InputPorcentagemDescontoUnitario_td_Linha_${props.item.Index}`}
                key={`Item_InputPorcentagemDescontoUnitario_td_Linha_${props.item.Index}`}
                title="Veja parâmetros: &#013;-Bloqueia desconto unitário no orçamento.&#013;-Altera preço de venda no Orçamento"
                classesInput={["input-navegavel"]}
            />
                }
        </td>,
        "PreservarDescontoUnitario": <td 
                id={`Item_PreservarDescontoUnitario_td_Linha_${props.item.Index}`}
                key={`Item_PreservarDescontoUnitario_td_Linha_${props.item.Index}`}
                className="_cursor-pointer _text-center">
            <input type="checkbox"
                disabled={context.orcamento.SomenteLeitura}
                checked={item.PreservaDesconto ?? false}
                onChange={e => onModificadoPreservarDescontoUnitario(e.target.checked)} 
                id={`Item_InputPreservarDescontoUnitario_td_Linha_${props.item.Index}`}
                key={`Item_InputPreservarDescontoUnitario_td_Linha_${props.item.Index}`}    
            />
        </td>,
        "PrecoTotal": <td key="PrecoTotal" style={{ minWidth: "110px" }} className="grid-itens__preco-total _cursor-pointer d" onClick={() => {
            context.onSelecionarItem(item)
            }}
            title={ props.item.PossuiSubItens && props.item.PrecoTinta > 0 ? `Preço Total Tinta: ${globalMU.formatarValorNumerico(props.item.PrecoTinta*props.item.Quantidade, context.numeroCasasDecimaisPrecoTotal, true)}` : undefined}
            id={`item-PrecoTotal-Linha-${props.item.Index}`}
        >   
            {
                globalMU.formatarValorNumerico(item.PrecoTotal, context.numeroCasasDecimaisPrecoTotal, true)
            }</td>,
        "PrecoSolTotal": <td className="_cursor-pointer d" key="PrecoSolTotal" style={{ minWidth: "110px" }} onClick={() => {
            context.onSelecionarItem(item)
        }} 
            id={`item-PrecoSolTotal-Linha-${props.item.Index}`}
            >
            {globalMU.formatarValorNumerico(item.PrecoSolTotal, context.numeroCasasDecimaisPrecoTotal, true)}
        </td>,
        "PrecoPendenciaTotal": <td className="_cursor-pointer d" key="PrecoPendenciaTotal" style={{ minWidth: "110px" }} onClick={() => {
            context.onSelecionarItem(item)
        }}
            id={`item-PrecoPendenciaTotal-Linha-${props.item.Index}`}
        >
            {globalMU.formatarValorNumerico(item.PrecoPendenciaTotal, context.numeroCasasDecimaisPrecoTotal, true)}
        </td>,
        "PercentualMarkUp": <td 
            id={`Item_PercentualMarkUp_td_Linha_${props.item.Index}`}
            key={`Item_PercentualMarkUp_td_Linha_${props.item.Index}`}
            >
            <InputNumerico
                valor={percentualMarkup}
                onValorModificado={confirmarAlteracaoPercentualMarkup}
                numeroCasasDecimais={2} // {context.numeroCasasDecimaisPreco}
                selecionaValorOnFocus={true}
                onKeyDown={e => controleNavegacaoGridItens.tratarEvento(e, ID_GRID_ITENS)}
                style={{ maxWidth: '140px', minWidth: '80px' }}
                classesInput={["input-navegavel"]}
                id={`Item_InputPercentualMarkUp_td_Linha_${props.item.Index}`}
                key={`Item_InputPercentualMarkUp_td_Linha_${props.item.Index}`}
                disabled={context.orcamento.SomenteLeitura || item.NaoPermiteAlterarPreco} />

        </td>,
        "DespesasInclusas": <td className="_cursor-pointer _text-center" 
            id={`Item_DespesasInclusas_td_Linha_${props.item.Index}`}
            key={`Item_DespesasInclusas_td_Linha_${props.item.Index}`}
            title="Despesa Inclusa" 
            onClick={() => {
            context.onSelecionarItem(item)
        }}>
            <input type="checkbox" disabled checked={item.DespesasInclusas ?? false}
                id={`Item_InputDespesasInclusas_td_Linha_${props.item.Index}`}
                key={`Item_InputDespesasInclusas_td_Linha_${props.item.Index}`}
            />
        </td>,
        "DescricaoTipoEntrega": 
        <td 
            key={`td-DescricaoTipoEntrega_Linha-${props.item.Index}`}
            id={`td-Item_Coluna_DescricaoTipoEntrega_Linha-${props.item.Index}`}
        >
            <select style={{ minWidth: '120px' }}
                title="Veja parâmetro: Manter filial de retirada ao trocar tipo de entrega de Futura para Expedição?"
                disabled={context.orcamento.SomenteLeitura 
                            || context.orcamento.TipoEntregaPadrao !== "" // 474918
                            || context.orcamento.OidFornecedorPorRepresentacao > 7 
                            || (item.CodigoTinta > 0 && item.Classe.toLowerCase() == "itempedidovendasubordinado")}
                key={`Select_Item_Coluna_DescricaoTipoEntrega_Linha-${props.item.Index}`}
                id={`Select_Item_Coluna_DescricaoTipoEntrega_Linha-${props.item.Index}`}
                value={(item.CodigoTipoEntrega) ?? ""}
                onChange={(e) => { 
                    context.onTipoEntregaAlterada(e.target.value as CodigoTipoEntrega, item.Identificador)
                }}
            >
                {context.tiposEntrega?.map((value) => (
                    <option key={value.Codigo} value={value.Codigo}>
                        {value.Descricao}
                    </option>
                ))}
            </select>

        </td>,
        "FilialRetirada": <td key={`FilialRetirada_Linha-${props.item.Index}`}
                id={`Item_Coluna_FilialRetirada_Linha-${props.item.Index}`}
                onClick={() => {
                    if (item.CodigoTipoEntrega === "C")
                        context.onSelecionarItem(item)
                    }}
            >

            {item.CodigoTipoEntrega !== "C" && <select value={(item.CodigoFilialRetirada) ?? ""} style={{ minWidth: '120px' , width: '-webkit-fill-available'}}
                id={`item-FilialRetirada_Linha-${props.item.Index}`}
                key={`item-FilialRetirada_Linha-${props.item.Index}`}
                disabled={context.orcamento.SomenteLeitura 
                                || context.orcamento.OidFornecedorPorRepresentacao > 7 
                                || context.orcamento.OidFornecedorPorRepresentacao > 7 
                                || (item.CodigoTinta > 0 && item.Classe.toLowerCase() == "itempedidovendasubordinado")
                            }
                onFocus={() => context.onFocusFilialRetirada(item.Identificador)}
                onChange={e => context.onFilialRetiradaAlterada(e.target.value, item.Identificador)}>

                <option value="" id={`Item_Ret_${props.item.Index}_Vazio`}></option>

                {filiaisRetirada?.length == 0 && globalMU.isNotNullOrEmpty(item.CodigoFilialRetirada) && <option value={item.CodigoFilialRetirada}>
                    {item.FilialRetirada}</option>}

                {filiaisRetirada?.map(f => <option value={f.Codigo} key={f.Oid.toString()}
                    id={`Item_Ret_${props.item.Index}_${f.Oid.toString()}`}
                >
                    {f.Descricao}
                </option>)}
            </select>}
        </td>,
        "FilialTransferencia": <td 
                key={`Item_Coluna_FilialTransferencia_Linha-${props.item.Index}`}
                id={`Item_Coluna_FilialTransferencia_Linha-${props.item.Index}`}
                onClick={() => {
                    if (item.CodigoTipoEntrega === "C")
                        context.onSelecionarItem(item)
                    }}
            >
            {item.CodigoTipoEntrega !== "C" && <select style={{ minWidth: '120px', width: '-webkit-fill-available' }}
                id={`item-FilialTransferencia_Linha-${props.item.Index}`}
                key={`item-FilialTransferencia_Linha-${props.item.Index}`}
                disabled={context.orcamento.OidFornecedorPorRepresentacao > 7 
                            || item.Classe == "Itempedidovendasubordinado" 
                            || globalMU.isNullOrEmpty(item.CodigoFilialRetirada) 
                            || context.orcamento.SomenteLeitura 
                            || item.BloquearAlteracaoLocalRetirada
                            || item.DesativarEdicaoFilialTransferencia 
                        }
                value={(item.CodigoFilialTransferencia) ?? ""}
                onFocus={() => context.onFocusFilialTransferencia(item.Identificador)}
                onChange={e => context.onFilialTransferenciaAlterada(e.target.value, item.Identificador)}>

                <option value="" id={`Item_Transf_${props.item.Index}_Vazio`}></option>

                {filiaisTransferencia.length == 0 && globalMU.isNotNullOrEmpty(item.CodigoFilialTransferencia) && <option value={item.CodigoFilialTransferencia}>
                    {item.FilialTransferencia}</option>}

                {filiaisTransferencia.map(f => <option value={f.Codigo} key={f.Oid.toString()}
                    id={`Item_Transf_${props.item.Index}_${f.Oid.toString()}`}
                >
                    {f.Descricao}
                </option>)}
            </select>}


        </td>,
        "ServicoAgregado": 
            <td 
                className="_cursor-pointer" title="Serviço Agregado" style={{ textAlign: 'center' }}
                id={`Item_ServicoAgregado_td_Linha_${props.item.Index}`}
                key={`Item_ServicoAgregado_td_Linha_${props.item.Index}`}
            >
            
            <input 
                type="checkbox" 
                disabled={context.orcamento.SomenteLeitura}
                id={`Item_InputServicoAgregado_td_Linha_${props.item.Index}`}
                key={`Item_InputServicoAgregado_td_Linha_${props.item.Index}`}
                checked={item.ServicoAgregado ?? false}
                onChange={(e) => {
                    abrirModalServicoAgregado(e.target.checked); 
                    if (!e.target.checked) {
                        context.onRemoverServicoAgregado(item.Identificador);
                    }
                }}  
            />
            {
                exibirServicosAgregados &&
                <ModalServicosAgregadosContainer 
                    item={item} 
                    onFechar={(e) => {abrirModalServicoAgregado(false); }}
                />
            }
            
        </td>,
        "TipoFaturamento": <td 
            key={`Item_TipoFaturamento_td_Linha_${props.item.Index}`}
            id={`Item_TipoFaturamento_td_Linha_${props.item.Index}`}
            onClick={() => {
                if (item.CodigoTipoEntrega === "C") 
                    context.onSelecionarItem(item)
            }}
        >

            {item.CodigoTipoEntrega !== "C" && <select
                style={{ width: '-webkit-fill-available'}}
                disabled={item.Classe == "Itempedidovendasubordinado" 
                            || props.item.DesativarEdicaoTipoFaturamento // 466376
                            || bloquearFaturamentoDiretoClienteRetiradaOutroLocal  // 469010
                            || globalMU.isNullOrEmpty(item.CodigoFilialRetirada) 
                            || context.orcamento.SomenteLeitura 
                            || item.BloquearAlteracaoLocalRetirada}
                value={(item.CodigoTipoFaturamento) ?? ""}
                onChange={e => context.onFaturamentoAlterado(e.target.value, item.Identificador)}
                id={`Item_TipoFaturamento_td_Linha_${props.item.Index}`}
                key={`Item_TipoFaturamento_td_Linha_${props.item.Index}`}
            >
                <option value=""
                    id={`Item_TpFat_${props.item.Index}_Vazio`}
                ></option>
                {context.tiposFaturamento.map(tf => <option value={tf.Value} key={tf.Value}
                    id={`Item_TpFat_${props.item.Index}_${tf.Value.toString()}`}
                >{tf.Description}</option>)}
            </select>}
        </td>,
        "DataPrevisaoEntrega": <td
            id={`Item_DataPrevisaoEntrega_td_Linha_${props.item.Index}`}
            key={`Item_DataPrevisaoEntrega_td_Linha_${props.item.Index}`}
            onClick={() => {
                if (item.CodigoTipoEntrega === "C") 
                    context.onSelecionarItem(item)
            }}
            style={{
                backgroundColor: (tiposFreteDisponiveis ?? []).filter(tf => tf.EhFreteEspecial == false).length > 1 ? "green" : undefined,
                color: (tiposFreteDisponiveis ?? []).filter(tf => tf.EhFreteEspecial == false).length > 1 ? "white" : undefined,
            }}
        >
            {item.CodigoTipoEntrega !== "C" && 
            <InputDataCalendario
                disabled={context.orcamento.SomenteLeitura || (item.CodigoTinta > 0 && item.Classe.toLowerCase() == "itempedidovendasubordinado")
                    || item.BloquearEdicaoDataPrevisaoEntrega // 462218
                }
                className='_w-full'
                id={`Item_DataPrevisaoEntrega_Linha_${props.item.Index}`}
                key={`Item_DataPrevisaoEntrega_Linha_${props.item.Index}`}
                data={globalMU.converterDataHoraFormatoENComTParaDataFormatoPT(item.DataPrevisaoEntrega)}
                dataMaxima={context.dataMaximaParaPrevisaoEntrega}
                bloquearDataMenorQueHoje={true}
                onChange={e => {
                    context.onDataPrevistaAlterada(e, item.Identificador)
                 }}
                selecionaValorOnFocus
            />
                }
        </td>,
        "ValorSubstituicao": <td className="_cursor-pointer d" key="ValorSubstituicao" onClick={() => {
            context.onSelecionarItem(item)
        }}>
            {globalMU.formatarValorNumerico(item.ValorSubstituicao, 2, false)}
        </td>,
        "DataMarcadaEntrega": <td className="_cursor-pointer" 
                id={`Item_DataMarcadaEntrega_td_Linha_${props.item.Index}`}
                key={`Item_DataMarcadaEntrega_td_Linha_${props.item.Index}`}
                onClick={() => {
                    if (item.CodigoTipoEntrega === "C") 
                        context.onSelecionarItem(item)
                    }}
            >
                {item.CodigoTipoEntrega !== "C" && 
                <InputDataCalendario
                disabled={context.orcamento.SomenteLeitura || (item.CodigoTinta > 0 && item.Classe.toLowerCase() == "itempedidovendasubordinado")
                        || item.BloquearEdicaoDataMarcadaEntrega // 462218
                }
                    className='_w-full'
                    id={`Item_DataMarcadaEntrega_Linha_${props.item.Index}`}
                    key={`Item_DataMarcadaEntrega_Linha_${props.item.Index}`}
                    data={globalMU.converterDataHoraFormatoENComTParaDataFormatoPT(item.DataMarcadaEntrega)}
                    bloquearDataMenorQueHoje={true}
                    onChange={e => {
                        context.onDataMarcadaAlterada(e, item.Identificador)
                     }}
                    selecionaValorOnFocus
                />
                    }
    
        </td>,
        "DescricaoTurnoEntrega": <td 
            key={`Item_DescricaoTurnoEntrega_td_Linha_${props.item.Index}`}
            id={`Item_DescricaoTurnoEntrega_td_Linha_${props.item.Index}`}
            onClick={() => {
                if (item.CodigoTipoEntrega === "C") 
                    context.onSelecionarItem(item)
            }}
        
        >
            {item.CodigoTipoEntrega !== "C" && 
            <select style={{ minWidth: '120px' }}
                id={`Item_TurnoEntrega_Linha_${props.item.Index}`}
                key={`Item_TurnoEntrega_Linha_${props.item.Index}`}
                disabled={context.orcamento.SomenteLeitura || (item.CodigoTinta > 0 && item.Classe.toLowerCase() == "itempedidovendasubordinado")} 
                value={item.TurnoEntrega ?? ""}
                onChange={(e) => {  
                    if (globalMU.isNullOrEmpty(e.target.value) || Number(e.target.value) != item.TurnoEntrega) {
                        context.onTurnoAlterada(globalMU.isNullOrEmpty(e.target.value) ? null : e.target.value  as CodigoTurnoEntrega, item.Identificador)
                    }
                }}
            >
{/* 
                <option value=""></option>
                <option value={0}>Manhã</option> 
                <option value={1}>Tarde</option>
                <option value={2}>Noite</option>
                <option value={3}>Indiferente</option>
                 */}
                 <option value=""></option>
      {listaTurnoEntrega?.map((value, index) => ( // 475897
        <option 
           key={`${value.Value}-${index}`} 
           value={value.Value}
    >
          {value.Description}
        </option>
      ))}
            </select>
    }
        </td>,
        "VendaSobEncomenda": 
        <td 
            className="_cursor-pointer" 
            key={`Item_VendaSobEncomenda_td_Linha_${props.item.Index}`}
            id={`Item_VendaSobEncomenda_td_Linha_${props.item.Index}`}
            style={{ textAlign: 'center' }}
            title="Veja parâmetro: &#0013;-Tratar vendas sob encomenda&#0013;-Bloqueia a seleção automática da entrega posterior no orçamento  para item sob encomenda&#0013;-Solicitar senha de liberação para Vendas Sob Encomenda?&#0013;-Capacidade de carga - Desconsiderar itens de encomenda&#0013;-Capacidade de carga - Desconsiderar itens sem reserva de estoque"
            onClick={() => {
                    if (item.CodigoTipoEntrega === "C")
                        context.onSelecionarItem(item)
                    }}
        >
            {item.CodigoTipoEntrega !== "C" && 
            <input type="checkbox" 
                checked={item.VendaSobEncomenda ?? false}
                onChange={(e) => { 
                     
                    context.onAlterarVendaSobEncomenda(e.target.checked, item.Identificador, item) }
                }
                id={`Item_InputVendaSobEncomenda_td_Linha_${props.item.Index}`}
                key={`Item_InputVendaSobEncomenda_td_Linha_${props.item.Index}`}
                disabled={ context.orcamento.OidFornecedorPorRepresentacao > 7 // 456252 --- ficha 487245 ->removi o "(item.CodigoTinta > 0 && item.Classe.toLowerCase() == "itempedidovendasubordinado") || "
                                || context.desativarCheckboxesVendaSobEncomendaItens  // 444764
                                // 490854 || (item.VendaSobEncomenda && item.EncomendaAutomatica) } // 444764  // 444764
                                || (parametroVendaSobEncomenda != "2" && item.VendaSobEncomenda && item.EncomendaAutomatica)  // 444764/490854
                }
            ></input>
            }
            </td>,
        "EncomendaExpressa": 
            <td className="_cursor-pointer" 
                title="Encomenda Expressa" 
                style={{ textAlign: 'center' }}
                key={`Item_EncomendaExpressa_td_Linha_${props.item.Index}`}
                id={`Item_EncomendaExpressa_td_Linha_${props.item.Index}`}
                onClick={() => {
                    if (item.CodigoTipoEntrega === "C")
                        context.onSelecionarItem(item)
                }}
            >
                {item.CodigoTipoEntrega !== "C" && item.VendaSobEncomenda && 
                <input 
                    type="checkbox" 
                    id={`Item_InputEncomendaExpressa_td_Linha_${props.item.Index}`}
                    key={`Item_InputEncomendaExpressa_td_Linha_${props.item.Index}`}
                    checked={item.EncomendaExpressa ?? false}
                    onChange={(e) => { 
                         
                        context.onAlterarEncomendaExpressa(e.target.checked, item.Identificador, item) }}
                    disabled={(item.CodigoTinta > 0 && item.Classe.toLowerCase() == "itempedidovendasubordinado") || context.desativarCheckboxVendaEncomendaExpressaItens}
                ></input>
                }
            </td>,
        "EntregaPosterior": <td className="_cursor-pointer _text-center" 
            onClick={() => {
                context.onSelecionarItem(item)
            }}
            id={`Item_EntregaPosterior_td_Linha_${props.item.Index}`}   
            key={`Item_EntregaPosterior_td_Linha_${props.item.Index}`}   
        > 
        {item.CodigoTipoEntrega !== "C" &&  
        <input type="checkbox" checked={item.EntregaPosterior ?? false} onChange={(e) => { context.onAlterarEntregaPosterior(e.target.checked, item) }}
            id={`Item_InputEntregaPosterior_td_Linha_${props.item.Index}`}
            key={`Item_InputEntregaPosterior_td_Linha_${props.item.Index}`}
            title="Entrega Posterior"
            disabled={context.orcamento.SomenteLeitura || (item.CodigoTinta > 0 && item.Classe.toLowerCase() == "itempedidovendasubordinado")} />
        }
        </td>,
        "Mostruário": <td className="_text-center"
            id={`Item_Mostruario_td_Linha_${props.item.Index}`}
            key={`Item_Mostruario_td_Linha_${props.item.Index}`}
        >
            <input type="checkbox" checked={item.Mostruario ?? false}
                onChange={(e) => { context.onAlterarMostruario(e.target.checked, item) }}
                id={`Item_InputMostruario_td_Linha_${props.item.Index}`}
                key={`Item_InputMostruario_td_Linha_${props.item.Index}`}
                title="Mostruário"
                disabled={context.orcamento.SomenteLeitura} />
        </td>,
        "AliquotaIPI": <td className="_cursor-pointer d" key="AliquotaIPI" onClick={() => {
            context.onSelecionarItem(item)
        }}>{globalMU.formatarValorNumerico(item.AliquotaIPI, 2)}</td>,
        "ValorIPI": <td className="_cursor-pointer d" key="ValorIPI" onClick={() => {
            context.onSelecionarItem(item)
        }}>{globalMU.formatarValorNumerico(item.ValorIPI, 2)}</td>,
        "Classe": <td className="_cursor-pointer" key="Classe" onClick={() => context.onSelecionarItem(item)}>
            {item.CodigoClasse}
        </td>,
        "Ambiente": <td key="Ambiente" className="item__ambiente">

            <AmbienteItemComMenu
                ambientes={context.ambientes}
                proximaCor={context.proximaCorAmbiente}
                onAmbienteRemovido={(ambiente) => context.onExcluirAmbiente(ambiente, item.Identificador)}
                onSalvarNovoAmbiente={(ambiente) => context.onSalvarAmbiente(ambiente, item.Identificador)}
                onAmbienteSelecionado={(ambiente) => {
                    if (context.orcamento.SomenteLeitura) {
                        return
                    }

                    context.onAmbienteSelecionado(ambiente, item.Identificador)
                }}
                ambiente={{
                    nome: props.item.Ambiente,
                    cor: (context.ambientes ?? []).find(a => a.nome == props.item.Ambiente)?.cor ?? ""
                }}
                toggleLimparNovoAmbiente={context.toggleLimparNovoAmbiente}
                onMenuAmbientesAberto={props.onMenuAmbientesAberto}
                onExibicaoMenuAlterada={props.onExibicaoMenuAmbientesAlterada}
                onMouseSobreMenu={props.onMouseSobreMenuAmbientes} />


        </td>,
        "CentroDeCusto": <td key="CentroDeCusto">


            <input
                id={`input-CentroDeCusto-item-${props.item.Identificador}`}
                className="input-navegavel"
                placeholder="Pesquisar..."
                list={idListaCentroCusto}
                onChange={e => {
                    setNomeCentroCusto(e.target.value)
                    context.onBuscarOuInformarCentroCusto(e.target.value, item.Identificador)
                }}
                onKeyDown={e => controleNavegacaoGridItens.tratarEvento(e, ID_GRID_ITENS)}
                autoComplete="off"
                type="search"
                value={(nomeCentroCusto) ?? ""}
                disabled={context.orcamento.SomenteLeitura  || (item.CodigoTinta > 0 && item.Classe.toLowerCase() == "itempedidovendasubordinado")}
            >
            </input>

            <datalist id={idListaCentroCusto}>
                {context.centrosCusto.map(c => <option key={c.IdClienteCentroCusto} value={R.trim(c.NomeCentroCusto)} />)}
            </datalist>
        </td>,
        "PercentualDesconto": <td className="_cursor-pointer d" key="PercentualDesconto" onClick={() => {
            context.onSelecionarItem(item)
        }}>
            {globalMU.formatarValorNumerico(item.PercentualBonificacaoMaximaAvancada, 2)}
        </td>,
        "PercentualBonificacao": <td className="_cursor-pointer d" key="PercentualBonificacao" onClick={() => {
            context.onSelecionarItem(item)
        }}>
            {globalMU.formatarValorNumerico(item.PercentualBonificacao, 2)} 
        </td>,
        "PrioridadeMontagem": 
            <td className="_cursor-pointer _text-center" 
                key="PrioridadeMontagem" 
                onClick={() => { context.onSelecionarItem(item) }}> 
                <input type="checkbox"
                        checked={item.PrioridadeMontagem ?? false}
                        id={`Item_InputPrioridadeMontagem_td_Linha_${props.item.Index}`}
                        key={`Item_InputPrioridadeMontagem_td_Linha_${props.item.Index}`}
                        onChange={(e) => {
                            context.onAlterarPrioridadeMontagem(e.target.checked, item.Identificador) }}
                        disabled={context.orcamento.SomenteLeitura  || (item.CodigoTinta > 0 && item.Classe.toLowerCase() == "itempedidovendasubordinado")} 
                />
                {/* 456839 */}
            </td>,
        "PedidoCompra": <td key="PedidoCompra">
            <input type="text" style={{ width: '80px' }}
                id={`input-PedidoCompra-item-${props.item.Identificador}`}
                className="input-navegavel"
                value={(pedidoCompra) ?? ""}
                disabled={context.orcamento.SomenteLeitura  || (item.CodigoTinta > 0 && item.Classe.toLowerCase() == "itempedidovendasubordinado")}
                onChange={e => {
                    setPedidoCompra(e.target.value)
                    setDirty(prev => ({ ...prev, pedidoCompra: true }))
                }}
                onKeyDown={e => {
                    controleNavegacaoGridItens.tratarEvento(e, ID_GRID_ITENS)

                    if (dirty.pedidoCompra && R.includes(e.code, ["Enter", "NumpadEnter", "Tab"])) {
                        context.onEditarPedidoDeCompra(item.Identificador, pedidoCompra)
                    }
                }}
                onBlur={_e => {
                    if (dirty.pedidoCompra) {
                        context.onEditarPedidoDeCompra(item.Identificador, pedidoCompra)
                    }
                }} />
        </td>,
        "LinhaOrdemCompra": <td key="LinhaOrdemCompra">
            <input style={{ width: '80px' }}
                id={`input-LinhaOrdemCompra-item-${props.item.Identificador}`}
                title="Somente ficará habilitado se CLIENTE for selecionado e parâmetro [Permite informar a linha do pedido de compra no orçamento] ativado"
                className="input-navegavel"
                type="number"
                value={(linhaOrdemPedidoCompra) ?? ""}
                disabled={context.orcamento.SomenteLeitura || context.desativarEdicaoOrdemPedidoCompraItem}
                onChange={e => {
                    const onlyNums = e.target.value.replace(/\D/g, '');
                    const linhaOrdemCompra = Number(onlyNums)
                    if (linhaOrdemCompra > 999999)
                    {
                        globalMU.showErrorMessage("Valor máximo para a linha do pedido de compra é 999999.") // 476708
                        return
                    }
                    setLinhaOrdemPedidoCompra(e.target.value)
                    setDirty(prev => ({ ...prev, linhaOrdemPedidoCompra: true }))
                }}
                onKeyDown={e => {
                    controleNavegacaoGridItens.tratarEvento(e, ID_GRID_ITENS)

                    if (dirty.linhaOrdemPedidoCompra && R.includes(e.code, ["Enter", "NumpadEnter", "Tab"])) {
                        setDirty(prev => ({ ...prev, linhaOrdemPedidoCompra: false }))
                        context.onEditarLinhaOrdemPedidoCompraItem(item.Identificador, linhaOrdemPedidoCompra)
                    }
                }}
                onBlur={_e => {
                    if (dirty.linhaOrdemPedidoCompra) {
                        setDirty(prev => ({ ...prev, linhaOrdemPedidoCompra: false }))
                        context.onEditarLinhaOrdemPedidoCompraItem(item.Identificador, linhaOrdemPedidoCompra)
                    }
                }} />
        </td>,
        "Observacao": <td key="Observacao">
            <textarea
                id={`input-Observacao-item-${props.item.Identificador}`}
                className="input-navegavel"
                value={(observacaoDoItem) ?? ""}
                disabled={context.orcamento.SomenteLeitura}
                onChange={_e => {
                    setObservacaoDoItem(_e.target.value)
                    /*props.onMudarObs(e.target.value, props.item)*/
                }}
                onBlur={_e => {
                    context.onMudarObs(_e.target.value, props.item)
                }}
                maxLength={254}
                rows={1}
                style={{ resize: 'both' }}
            />
        </td>,
        "Cor": <td key="Cor" className="_cursor-pointer" onClick={() => context.onSelecionarItem(item)}>
            <span>{item.DescricaoCorTinta}</span>
        </td>,
        "ModeloProduto": <td key="Modelo" className="_cursor-pointer" onClick={() => context.onSelecionarItem(item)}>
            <span>{item.ModeloProduto}</span>
        </td>,
        "SistemaTintometrico": <td 
            id={`Item_SistemaTintometrico_td_Linha_${props.item.Index}`}
            key={`Item_SistemaTintometrico_td_Linha_${props.item.Index}`}
            className="_cursor-pointer" onClick={() => context.onSelecionarItem(item)}>
            <span>{item.NomeSistemaTintometrico}</span>
        </td>,

        "Acoes": <td
            id={`Item_Acoes_td_Linha_${props.item.Index}`}
            key={`Item_Acoes_td_Linha_${props.item.Index}`}
            className={estilosGridItens.colunaAcoesNormal}
        >
            {renderBotoesAcoesItem("")}
        </td>

    }
/*


Atenção, se incluir alguma coluna no grid de itens, tem que incluir tambem na consulta de itens (ItemConsultaItens)



*/
    return <>
        <tr
            key={`${props.item.Identificador}_${props.item.Index}_${props.indexItem}`}
            id={`Item_GridLinha-${props.item.Index}_${props.indexItem}`}
            // 491123 — em touch não há :hover, então é o clique/toque na linha que libera o painel de
            // ações flutuante. Fica no <tr> (e não em cada <td>) porque o clique de qualquer célula
            // borbulha até aqui — inclusive das células que não chamam context.onSelecionarItem.
            onClick={() => props.onLinhaClicada?.()}
            className={
                clsx(
                    `item-orcamento-identificador-${item.Identificador}`,
                    `item-orcamento-ordem-${item.OrdemItem}`,
                    // 491123 — em tablet/Android não há :hover de verdade (touch), então o painel de
                    // ações flutuante (gatilhoAcoesFlutuantes) nunca aparecia: essa classe dá ao CSS
                    // um gatilho equivalente ao hover. Amarrada à ÚLTIMA linha clicada, não a
                    // item.selecionado: a seleção é múltipla, então o painel aparecia em todas as
                    // linhas selecionadas de uma vez (ver "@media (hover: none)" em grid-itens.module.scss)
                    props.exibirAcoesFlutuantesTouch && estilosGridItens.linhaAcoesFlutuantesTouch,
                    // 493427 — linha saindo pela exclusao na coluna Acoes
                    removendo && estilosGridItens.linhaRemovendo
                )
            }
            style={{
                backgroundColor: !item.selecionado ? undefined : (globalMU.isNullOrEmpty(context.corItemSelecionado) ? "#fafaad" : context.corItemSelecionado)
            }}

        >

            {/* <td key="cor" className={
                `${clsx("_cursor-pointer", estilosGridItens.colunaVazia, estilosGridItens.colunaFixa, estilosGridItens.primeiraColuna)}`
            }
                onClick={() => {
                    context.onSelecionarItem(item)
                }}
                title={!globalMU.isNullOrEmpty(props.item.DescricaoLegenda) ? props.item.DescricaoLegenda : undefined }
                id={`Item_cor_td_Linha_${props.item.Index}`}
                style={{
                    boxShadow: globalMU.isNullOrEmpty(props.item.Cor) || props.item.Cor == "#000000" ? undefined : `25px 0 ${props.item.Cor} inset`,
                    ...obterStylePrimeiraColuna()
                }}>
                <div className={item.OrdemItem === "I" ? estilosLegenda.produtoImportadoCor : null} />


                {item.OfertaSelecionada == 1 && parametroOfertaSeletiva // 434018
                            &&  <FontAwesomeIcon icon={faCheck} style={{color: "white"}} title="Oferta Selecionada" 
                                    id={`Item_Icone_OfertaSeletivaSelecionada_td_Linha_${props.item.Index}`}
                                    key={`Item_Icone_OfertaSeletivaSelecionada_td_Linha_${props.item.Index}`}
                                    />}


                {(item.Alertas ?? []).length > 0 && <Popover
                    id={`Item_PopoverIcone_Alerta_td_Linha_${props.item.Index}`}
                    key={`Item_PopoverIcone_Alerta_td_Linha_${props.item.Index}`}
                    conteudo={item.Alertas.map(a => a.Mensagem).join("\n")}
                    exibirConteudoComoTitle={true}>
                    <FontAwesomeIcon 
                        icon={faTriangleExclamation} 
                        style={{ color: '#F00' }} 
                        className="_text-3xl" 
                        id={`Item_Icone_Alerta_td_Linha_${props.item.Index}`}
                    />
                </Popover>}

                {(item.Alertas ?? []).length === 0 && props.item.VendendoProdutoSemEstoque  // 463440
                    &&
                    <Popover
                        id={`Item_PopoverIcone_Informacao_td_Linha_${props.item.Index}`}
                        key={`Item_PopoverIcone_Informacao_td_Linha_${props.item.Index}`}
                        conteudo={`Venda de Produto Sem Estoque Disponível`}  // 463440
                        exibirConteudoComoTitle={true}
                    >
                    <FontAwesomeIcon 
                        icon={faCircleInfo} 
                        style={{ color: 'gray' }} 
                        className="_text-3xl" 
                        id={`Item_Icone_Informacao_td_Linha_${props.item.Index}`}  // 463440
                    />
                </Popover>}
            </td> */}
            <ColunaCor
                item={item}
                indexItem={props.indexItem}
            />

            {context.colunas?.filter(exibirColuna).map((coluna, indexColuna) => {

                return coluna.Nome in componentesColunas ? componentesColunas[coluna.Nome] :
                    coluna.ehEstoqueFilial 
                    ? <td
                            onClick={() => context.onSelecionarItem(item)}
                            id={`Item_${coluna.Nome}_td_Linha_${props.indexItem}_${indexColuna}`}
                            key={`Item_${coluna.Nome}_td_Linha_${props.item.Identificador}_${indexColuna}`}
                        >
                        {globalMU.formatarValorNumerico((item.ListEstoqueProduto?.Estoques ?? []).find(e => `F${e.CodigoFilial}` == coluna.Nome)?.QuantidadeDisponivel, 3, false)}
                    </td> :
                        <td key={`col_placeholder_${coluna.Nome}_${props.item.Identificador}_${indexColuna}`}></td>
            })}

            {/* Sempre renderizado, independente da coluna "Acoes" estar selecionada/visível:
                é o único jeito de acessar o menu de ações quando essa coluna está oculta */}
            <td
                id={`Item_Acoes_td_Linha_Flutuante_${props.item.Index}`}
                key={`Item_Acoes_td_Linha_Flutuante_${props.item.Index}`}
                className={clsx(
                    estilosGridItens.acoesFlutuantesColuna,
                    // 491123 — só a primeira linha precisa vencer o empate de stacking contra a
                    // linha seguinte (painel desce nela, ver gatilhoAcoesFlutuantesPrimeiraLinha)
                    props.indexItem === 0 && estilosGridItens.acoesFlutuantesColunaPrimeiraLinha
                )}
            >

                {!props.ocultarAcoesFlutuantes && <div
                    className={clsx(
                        estilosGridItens.gatilhoAcoesFlutuantes,
                        // 491123 — na primeira linha não há espaço acima para o painel "subir" (vazaria
                        // para fora da grid/sobre o cabeçalho): inverte a ancoragem, painel desce
                        props.indexItem === 0 && estilosGridItens.gatilhoAcoesFlutuantesPrimeiraLinha
                    )}
                    id={`Item_Acoes_GatilhoFlutuante_Linha-${props.item.Index}`}
                >
                    <div className={estilosGridItens.acoesFlutuantes}>
                        {renderBotoesAcoesItem("_Flutuante")}
                    </div>
                </div>}
            </td>

        </tr>
    </>
}

export {
    Item,
    ItemProps
};